import { STATUS_META, type PostStatus } from '../api/types'
import { cn } from '../lib/cn'

export type StatusPillProps = {
  status: PostStatus
}

export const StatusPill = ({ status }: StatusPillProps): JSX.Element => {
  const meta = STATUS_META[status]

  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-dune-border bg-white px-3 py-1.5">
      <span className={cn('h-1.5 w-1.5 rounded-full', meta.dotClass)} />
      <span
        className={cn(
          'font-display text-[11px] font-medium uppercase tracking-wider',
          meta.textClass,
        )}
      >
        {meta.label}
      </span>
    </span>
  )
}
